<app-menu>
    <ng-container *ngIf="hasPageAccess">
    <div style="display: flex; justify-content: space-between">
        <h1 style="margin-top: 10px;">Admin User Manager</h1>
        <button matTooltip="Add New User" (click)="addUser()" style="width: 5%;" mat-button color="primary">
            <i class="fa-solid fa-lg fa-plus"></i><i class="fa fa-lg fa-user" aria-hidden="true"></i>
        </button>
    </div>
    <div style="display: flex; flex-wrap: nowrap;">
        <span style="margin-right: -5px; background-color: lightgray; padding: 13px 20px; border-radius: 5px; align-self: flex-start;"><i
                class="fas fa-2x fa-search"></i></span>
        <div style="display: flex; justify-content: flex-start; gap: 15px; flex-wrap: nowrap; width: 70%;">
            <span style="flex-basis: 30%;">
                <mat-form-field style="width: 100%;">
                    <mat-label>Username</mat-label>
                    <input matInput [(ngModel)]="filterUsername" (input)="onInputChange()">
                </mat-form-field>
            </span>
            <span style="flex-basis: 30%;">
                <mat-form-field style="width: 100%;">
                    <mat-label>Role</mat-label>
                    <mat-select (selectionChange)="onSelectionRole($event)" style="width: 100%;">
                        <mat-option *ngFor="let type of roleList" [value]="type">
                            {{type}}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </span>
            <span style="flex-basis: 30%;">
                <mat-form-field style="width: 100%;">
                    <mat-label>Status</mat-label>
                    <mat-select (selectionChange)="onSelectionStatus($event)" style="width: 100%;">
                        <mat-option *ngFor="let type of statusList" [value]="type">
                            {{type}}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </span>
        </div>
    </div>

    <ag-grid-angular style="width: 100%; height: 100%;" class="ag-theme-alpine" (gridReady)="onGridReady($event)"
        [defaultColDef]="defaultColDef" [columnDefs]="userColumnDefs" [rowData]="users" #agGrid></ag-grid-angular>
    </ng-container>
</app-menu>